<template>
  <div>
    <slot :loading="loading" :data="data" :meta="meta" :message="message"></slot>
  </div>
</template>

<script>
export default {
  props: {
    uri: {
      type: String,
      required: true,
    },

    takeAtLeast: {
      type: Number,
      default: 0,
    },

    query: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      data: null,
      meta: null,
      loading: false,
      message: null,
    };
  },

  created() {
    this.load();
  },

  watch: {
    uri() {
      this.load();
    },

    query() {
      this.load();
    },
  },

  methods: {
    load() {
      this.loading = true;

      this.$http
        .get(this.uri, { params: this.query })
        .takeAtLeast(this.takeAtLeast)
        .then((response) => {
          this.loading = false;
          this.data = response.data.data;
          this.meta = response.data.meta;
        })
        .catch((err) => {
          this.message = err.message;
          this.loading = false;
        });
    },
  },
};
</script>
